'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useEffect } from 'react';
import { ROUTES } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { switchMyPageUser, useMyPageStore } from '@/stores/useMyPageStore';
import { gtmDatasets } from '@/utils/analytics/gtm';
import { MenuIconItem } from './MenuIconItem';
import { DEFAULT_QUICK_ICON_IDS, getPersonalizedQuickIcons, getVisibleMenuItems, MENU_ITEMS } from './MenuItems';
const variantClass = {
  mobile: {
    section: 'px-20 pb-20',
    nav: 'grid grid-cols-4 place-items-center gap-y-20'
  },
  desktop: {
    section: 'px-64 pb-20',
    nav: 'grid grid-cols-4 place-items-start gap-x-16 gap-y-20'
  }
} as const;
export const QuickIconGrid = t0 => {
  const $ = _c(14);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "mobile" : t1;
  const myInfo = useAuthStore(_temp);
  const isLogin = useAuthStore(_temp2);
  const subDomain = useDeviceInfoStore(_temp3);
  const menuAccess = useMyPageStore(_temp4);
  const trackAccess = useMyPageStore(_temp5);
  const visibleMenuItems = getVisibleMenuItems(MENU_ITEMS, subDomain);
  let t2;
  if ($[0] !== myInfo) {
    t2 = () => {
      if (myInfo?.id) {
        switchMyPageUser(String(myInfo.id));
      }
    };
    $[0] = myInfo;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = myInfo?.id;
  let t4;
  if ($[2] !== t3) {
    t4 = [t3];
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useEffect(t2, t4);
  const ids = myInfo?.id ? getPersonalizedQuickIcons(menuAccess, DEFAULT_QUICK_ICON_IDS, 8) : DEFAULT_QUICK_ICON_IDS;
  const quickItems = ids.map(id => visibleMenuItems.find(item => item.id === id)).filter(_temp6);
  const classes = variantClass[variant];
  const t5 = classes.section;
  const t6 = classes.nav;
  const t7 = "\uC790\uC8FC \uC4F0\uB294 \uBA54\uB274";
  let t8;
  if ($[4] !== isLogin || $[5] !== trackAccess || $[6] !== variant) {
    t8 = item_1 => <MenuIconItem key={item_1.id} item={item_1} size="sm" href={item_1.isLoginRequired !== false && !isLogin ? ROUTES.LOGIN.withSearchParams({
      searchParams: {
        redirect: item_1.href
      }
    }) : item_1.href} onClick={() => {
      if (isLogin && item_1.href !== "#") {
        trackAccess(item_1.id);
      }
    }} className={cn("[-webkit-tap-highlight-color:transparent]", variant === "desktop" && "justify-self-center")} {...gtmDatasets.clickSnb({
      menu_name: item_1.label
    })} />;
    $[4] = isLogin;
    $[5] = trackAccess;
    $[6] = variant;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = quickItems.map(t8);
  let t10;
  if ($[8] !== classes.nav || $[9] !== t9) {
    t10 = <nav className={t6} aria-label={t7}>{t9}</nav>;
    $[8] = classes.nav;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== classes.section || $[12] !== t10) {
    t11 = <section className={t5}>{t10}</section>;
    $[11] = classes.section;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  return t11;
};
function _temp(state) {
  return state.myInfo;
}
function _temp2(state_0) {
  return state_0.isLogin;
}
function _temp3(state_1) {
  return state_1.subDomain;
}
function _temp4(state_2) {
  return state_2.menuAccess;
}
function _temp5(state_3) {
  return state_3.trackAccess;
}
function _temp6(item_0) {
  return !!item_0;
}